import { render, staticRenderFns } from "./QuestionOption.vue?vue&type=template&id=0107fce1&scoped=true&"
import script from "./QuestionOption.vue?vue&type=script&lang=js&"
export * from "./QuestionOption.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOption.vue?vue&type=style&index=0&id=0107fce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107fce1",
  null
  
)

export default component.exports